import { PositionsAllocationModalComponent } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.component';
import { PositionsAllocationModalDataProvider } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.data.context';
import { PositionsAllocationViewUIProvider } from 'pages/SettingsPage/PositionsSettingsPage/B2BPositionsSettingsPage/modals/PositionsByLocation/PositionsAllocationModal.ui.context';
import { FC } from 'react';

export const PositionsAllocationModal: FC = () => {
  return (
    <PositionsAllocationViewUIProvider>
      <PositionsAllocationModalDataProvider>
        <PositionsAllocationModalComponent />
      </PositionsAllocationModalDataProvider>
    </PositionsAllocationViewUIProvider>
  );
};
